module.exports = __webpack_public_path__ + "img/1.decf73c1.jpg";